import {
  DefaultRole,
  EventTypeEnum,
  ItemTypeEnum,
  Event,
  Item,
  LessonPlan,
  PermissionRole,
  StreamRoleEnum
} from 'able-lib'

export const FUSIONAUTH_USER = 'user'
export const TOKEN_NAME = 'token'
export const TOKEN_REFRESH_NAME = 'token_refresh'

// TODO: fetch from database
export const LEVELS = [
  {
    id: 10,
    name: 'NURSERY'
  },
  {
    id: 20,
    name: 'JUNIOR KINDER'
  },
  {
    id: 30,
    name: 'SENIOR KINDER'
  },
  {
    id: 40,
    name: 'KINDERGARTEN'
  },
  {
    id: 50,
    name: '1ST GRADE'
  },
  {
    id: 60,
    name: '2ND GRADE'
  },
  {
    id: 70,
    name: '3RD GRADE'
  },
  {
    id: 80,
    name: '4TH GRADE'
  },
  {
    id: 90,
    name: '5TH GRADE'
  },
  {
    id: 100,
    name: '6TH GRADE'
  },
  {
    id: 110,
    name: '7TH GRADE'
  },
  {
    id: 120,
    name: '8TH GRADE'
  },
  {
    id: 130,
    name: '9TH GRADE'
  },
  {
    id: 140,
    name: '10TH GRADE'
  },
  {
    id: 150,
    name: '11TH GRADE'
  },
  {
    id: 160,
    name: '12TH GRADE'
  }
]

// TODO: fetch from database
export const SUBJECTS = [
  {
    id: 0,
    name: 'Practice'
  },
  {
    id: 1,
    name: 'ENGLISH'
  },
  {
    id: 2,
    name: 'MATH'
  },
  {
    id: 3,
    name: 'SCIENCE'
  },
  {
    id: 4,
    name: 'FILIPINO'
  },
  {
    id: 5,
    name: 'CIVICS & CULTURE'
  },
  {
    id: 6,
    name: 'LIFE SKILLS'
  },
  {
    id: 7,
    name: 'CHARACTER EDUCATION'
  }
]

export const ROLES = {
  ADMINISTRATOR: {
    id: 1,
    name: DefaultRole.ADMINISTRATOR
  },
  TEACHER: {
    id: 2,
    name: DefaultRole.TEACHER
  },
  STUDENT: {
    id: 3,
    name: DefaultRole.STUDENT
  },
  PARTICIPANT: {
    id: 4,
    name: PermissionRole.PARTICIPANT
  },
  HOST: {
    id: 5,
    name: StreamRoleEnum.HOST
  },
  ATTENDEE: {
    id: 6,
    name: StreamRoleEnum.ATTENDEE
  },
  AUDITOR: {
    id: 7,
    name: StreamRoleEnum.AUDITOR
  },
  EDITOR: {
    id: 8,
    name: PermissionRole.EDITOR
  }
}

export const NEW_LESSONPLAN_TEMPLATE: LessonPlan = {
  assessment: null,
  enhancement: null,
  lesson: null,
  level: {
    id: null,
    name: null
  },
  number: null,
  objective: null,
  platform: null,
  resources: null,
  status: null,
  subject: {
    id: null,
    name: null
  },
  year: null
}

const ITEM_TEMPLATE: Item = {
  type: ItemTypeEnum.LESSON,
  order: '1',
  content: {
    title: '',
    body: '',
    annotation: {},
    contentAssets: []
  },
  items: [],
  itemUsers: [],
  itemGroups: [],
  itemSettings: [],
  lessonPlan: NEW_LESSONPLAN_TEMPLATE,
  startDateTime: new Date().getTime(),
  endDateTime: new Date().getTime() + (60 * 60 * 1000)
}

export const NEW_ITEM_TEMPLATE: Item = {
  ...ITEM_TEMPLATE,
  originalItem: ITEM_TEMPLATE
}

export const NEW_EVENT_TEMPLATE: Event = {
  id: '',
  name: '',
  startDatetime: new Date(new Date().setHours(0, 0, 0, 0)),
  endDatetime: new Date(new Date().setHours(23, 59, 59, 59)),
  type: EventTypeEnum.DAY
}
